import { render, staticRenderFns } from "./PurchasePricesEdit.vue?vue&type=template&id=2f05744e"
import script from "./PurchasePricesEdit.vue?vue&type=script&lang=js"
export * from "./PurchasePricesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports